var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#798491",
    d: "M12.162 9.34a.857.857 0 1 1 1.212 1.212l-3.576 3.576a1.29 1.29 0 0 0 0 1.819 1.29 1.29 0 0 0 1.818 0l6.667-6.667c1.373-1.373 1.298-3.551 0-4.85-1.298-1.297-3.476-1.372-4.849 0l-6.667 6.668c-2.186 2.186-2.145 5.733 0 7.879s5.693 2.186 7.88 0l3.576-3.576a.857.857 0 1 1 1.212 1.212l-3.576 3.576c-2.862 2.862-7.495 2.81-10.304 0s-2.862-7.441 0-10.303l6.667-6.667c2.062-2.062 5.324-1.95 7.273 0 1.95 1.949 2.062 5.211 0 7.273l-6.667 6.667c-1.137 1.137-3.04 1.203-4.242 0-1.203-1.203-1.138-3.105 0-4.243z"
  })));
};
export default SvgAttach;